import { useMutation, useQueryClient } from '@tanstack/react-query';
import { placeAPSOrder } from '../api';
import { DoctorFormData } from '../types';
import { getQueryKey } from './useDoctors';

const useSaveOrder = (
  applicationId: number,
  taskId: number,
  onSuccess: () => void,
  onError?: (error: any) => void,
) => {
  const queryClient = useQueryClient();
  const { mutateAsync: placeOrder, isLoading } = useMutation({
    mutationFn: (formData: DoctorFormData) =>
      placeAPSOrder(applicationId, taskId, formData),
    onSuccess: () => {
      // Invalidate doctors query to refresh the list after successful order
      queryClient.invalidateQueries({
        queryKey: getQueryKey(applicationId, taskId),
      });
      onSuccess();
    },
    onError,
  });

  return { placeOrder, isLoading };
};

export default useSaveOrder;
